import { Watch } from "@mui/icons-material";
import { useSessionContext } from "@/contexts/SessionContext";
import { IFeatures } from "@/utils/interfaces";
import { WearableObservations } from "./WearableObservations";

/**
 * Rota da página de dispositivos (wearable). Fica fora do menu lateral:
 * o acesso é pelo card "Dados Wearable" no dashboard do paciente.
 */
export function useWearableObservations() {
  const { access } = useSessionContext();

  const configs: IFeatures = {
    active: access.type === "patient",
    path: "/wearableobservations",
    icon: Watch,
    text: "Dados Wearable",

    component: () => <WearableObservations />,
  };
  return configs;
}
